import { inject, Injectable, signal } from '@angular/core';
import { Resolve } from '@angular/router';
import { StoreInterfaceService } from '../services/store-interface.service';
import { FormulaModelStore } from '../stores/formula-model.store';
import { UnitStore } from '../stores/unit.store';
import { FormulaModel, FormulaModelsResolvedData, FormulaModelType } from '../types/formula.interface';
import { Unit } from '../types/unit.interface';

@Injectable({
  providedIn: 'root',
})
export class FormulaModelsResolver implements Resolve<FormulaModelsResolvedData> {
  private readonly unitsStore = inject(UnitStore);
  private readonly formulaModelsStore = inject(FormulaModelStore);
  private readonly storeService = inject(StoreInterfaceService);

  async resolve(): Promise<FormulaModelsResolvedData> {
    const dataLoaded = signal(false);
    void this.unitsStore.loadAll().then(() => {
      void this.formulaModelsStore.loadAll().then(() => {
        dataLoaded.set(true);
      });
    });
    return {
      formulaModels: this.storeService.getData<FormulaModel>('FormulaModel'),
      units: this.storeService.getData<Unit>('Unit'),
      dataLoaded,
      formulaModelType: FormulaModelType.FORMULA,
    };
  }
}
